import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type SetDefaultTemplateSuccessModalProps = {
  open: boolean
  handleClose: VoidFunction
}

export function SetDefaultTemplateSuccessModal({ open, handleClose }: Readonly<SetDefaultTemplateSuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="set-default-template-success"
      data-testid="set-default-template-success-modal"
    >
      <AcknowledgeModal
        result="positive"
        title={t('dialog.templates.setDefault.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="set-default-success-modal-btn"
      >
        {t('dialog.templates.setDefault.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
